export default "__VITE_ASSET__f2929eaa__"